// @mui
import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import useSettings from '../../hooks/useSettings';
// layouts
import Layout from '../../layouts';
// components
import Page from '../../components/Page';
// sections
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import useLocales from '../../hooks/useLocales';
import { PATH_PAGE, PATH_RESOURCE } from '../../routes/paths';
import Question from '../../sections/blog/question/QuestionSection';

const RootStyle = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(10),
  paddingTop: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
  },
}));
// ----------------------------------------------------------------------

Index.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

// ----------------------------------------------------------------------

export default function Index() {
  const { translate } = useLocales();
  const { themeStretch } = useSettings();

  return (
    <Page title={translate('question.title')} description={translate('question.description')}>
      <RootStyle>
        <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
          <HeaderBreadcrumbs
            heading={translate('question.title')}
            links={[
              { name: translate("menu.home"), href: PATH_PAGE.home },
              { name: translate("menu.question"), href: PATH_RESOURCE.questions }
            ]}
          />
          <Question />
        </Container>
      </RootStyle>
    </Page>
  );
}
